export default __webpack_public_path__ + "static/media/tele-plan-carousel-3-tata.8dea89fd.png";